export enum StatisticTypeTag {
    Article = 'article',
    OfferCreator = 'offer-creator'
}

export interface StatisticType {

    id: number;

    tag: StatisticTypeTag;

    label: string;
}
